import React from 'react'
import PropTypes from 'prop-types'
import {
  BaseComponent
} from 'belle-js'
import DocumentListItemColumn from './DocumentListItemColumn'
import styles from './DocumentList.module.scss'
import { fetchFile } from 'utils/Client/files'
import { InternalServerError } from 'utils/errorTypes'
import { trackAnalyticsEvent } from 'analytics'

class DocumentListItem extends BaseComponent {

  constructor (props) {
    super(props)
    this.state = { downloading: false }
    this.bind('handleDownloadFile')
  }

  handleDownloadFile () {
    const {
      handleDownloadError,
      document: { id, name, type }
    } = this.props

    this.setState({ downloading: true })
    const toBlob = (resp) => {
      if (resp.ok) {
        return resp.blob()
      }
      throw new InternalServerError()
    }

    const fileString = `${name}.${type.toLowerCase()}`
    fetchFile(id).then(toBlob)
      .then((blob) => {
        window.download(blob, fileString)
      })
      .catch((e) => {
        handleDownloadError(fileString)
      })
      .finally(() => this.setState({ downloading: false }))

    trackAnalyticsEvent('Download File Clicked')
  }

  truncateDocumentName (name) {
    const MOBILE_MAX_LENGTH = 60
    const DESKTOP_MAX_LENGTH = 80
    const nameLength = name.length

    if (this.props.isMobile) {
      if (nameLength <= MOBILE_MAX_LENGTH) {
        return name
      } else {
        return `${name.substring(0, MOBILE_MAX_LENGTH)}...`
      }
    }

    if (nameLength <= DESKTOP_MAX_LENGTH) {
      return name
    } else {
      return `${name.substring(0, DESKTOP_MAX_LENGTH)}...`
    }
  }

  render () {
    const {
      documentType,
      document: { name, type, date },
      isMobile
    } = this.props
    const MY_UPLOADS_TYPE = 'my uploads'
    const { downloading } = this.state
    const isMyUploadsType = documentType === MY_UPLOADS_TYPE
    const icon = downloading ? 'loading' : 'download'

    return (
      <div className={styles.DocumentListItem}>
        <DocumentListItemColumn
          data-test-id="document-name-column"
          value={this.truncateDocumentName(name)}
          icon={icon}
          className={styles.fileName}
          onContentClick={this.handleDownloadFile} />
        { isMyUploadsType &&
        <div className={styles.documentListItemMobileWrapper}>
          <DocumentListItemColumn
            data-test-id="document-type-column"
            header="Type"
            value={type}
            className={styles.fileType} />
        </div>}
        { isMyUploadsType &&
        <div className={styles.documentListItemMobileWrapper}>
          <DocumentListItemColumn
            data-test-id="document-date-column"
            header="Date shared"
            value={date}
            className={styles.dateShared} />
        </div>}
        { !isMyUploadsType && isMobile &&
        <div className={styles.documentListItemMobileWrapper}>
          <DocumentListItemColumn
            data-test-id="document-date-column"
            header="Date shared"
            value={date}
            className={styles.dateShared} />
          <DocumentListItemColumn
            data-test-id="document-type-column"
            header="File"
            value={type}
            className={styles.fileType} />
        </div>}
        { !isMyUploadsType && !isMobile &&
        <div className={styles.documentListItemMobileWrapper}>
          <DocumentListItemColumn
            data-test-id="document-type-column"
            header="Type"
            value={type}
            className={styles.fileType} />
          <DocumentListItemColumn
            data-test-id="document-date-column"
            header="Date shared"
            value={date}
            className={styles.dateShared} />
        </div>}
      </div>
    )
  }

}

DocumentListItem.propTypes = {
  documentType: PropTypes.string.isRequired,
  document: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired
}


export default DocumentListItem



// WEBPACK FOOTER //
// ./src/components/Client/DocumentList/DocumentListItem.jsx